import { formatDateWithTimeAMPM, gridSize, gridSizeMdLg4, handleErrorForm, limpiarProductosInventario, newKitInventarioSchema, ROUTER_PATHS, texto, useLoaders, useTableColumnsInventario } from "@/shared";
import { CustomAutocomplete, CustomTextArea, CustomTextField, SampleTable, SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui";
import { BODEGAS, Ubicaciones } from "@/shared/interfaces/erp/inventario";
import { useAuthStore } from "@/store/auth";
import { MaterialesKey, useBodegaStore, useMaterialesUtilizadosStore } from "@/store/erp";
import { Grid, Paper } from "@mui/material";
import { useForm } from "react-hook-form";
import ModalProductoSelectComponente from "@/erp/inventario/ingreso-producto/shared/componente/ModalProductoSelectComponente";
import { ErrorMessagesForm, MaterialTransferido } from "@/shared/interfaces";
import { useFetchUbicaciones } from "@/shared/actions/erp";
import { IKitInventario, KitInventariableForm } from "@/shared/interfaces/erp/inventario/kit-inventario.interface";
import { fetchPostCreateKitInventario, fetchPutEditKitInventario } from "@/shared/actions/erp/kitinventario/kitInventario.actions";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface SaveKitInventariableProps {
  title: string
  dataKitInventario?: IKitInventario
}

export default function SaveKitInventariable({
  title,
  dataKitInventario
}: SaveKitInventariableProps) {

  ///* Form
  const form = useForm<KitInventariableForm>({
    resolver: yupResolver(newKitInventarioSchema)
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = form;


  ///* hook
  const navigate = useNavigate();

  const { bodegas, isLoadingbodegas } = useBodegaStore();
  const razon_social = useAuthStore(s => s.user)?.razon_social
  const { columnCreateKitInventario } = useTableColumnsInventario({
    key: MaterialesKey.selectItemKit
  });

  const addSelectedItemProducto = useMaterialesUtilizadosStore(s => s.addSelectedItemProducto);
  const selectItemKit = useMaterialesUtilizadosStore(s => s.selectItemKit);
  const clearSelectedItems = useMaterialesUtilizadosStore(s => s.clearSelectedItems);

  ///* React Query
  const { data: ubOrigen, isLoading: isLoaUbOrigen, } = useFetchUbicaciones({
    page_size: 600,
    bodega: form.getValues().bodega!
  }, !!form.watch('bodega'));

  const {
    mutateAsync: mutateAsyncCreateKit
  } = fetchPostCreateKitInventario();

  const {
    mutateAsync: mutateAsyncEditKit,
    isPending: isPendingEditKit
  } = fetchPutEditKitInventario({
    navigate,
    redirect: true,
    returnUrl: ROUTER_PATHS.inventario.kitInventariable
  })

  useEffect(() => {

    if (dataKitInventario) {
      reset(dataKitInventario)

      dataKitInventario.productos.forEach(element => {
        addSelectedItemProducto(element, MaterialesKey.selectItemKit);
      });
    }

    return () => {
      clearSelectedItems(MaterialesKey.selectItemKit)
    }

  }, [])


  ///* Handle
  const onSubmit = async (data: KitInventariableForm) => {

    try {
      const sendForm = {
        ...data,
        productos: limpiarProductosInventario(selectItemKit)
      } as any

      console.log('data send', sendForm);


      if (dataKitInventario) {
        mutateAsyncEditKit({
          data: sendForm,
          id: dataKitInventario.id_kitinventario
        })
        return
      }

      const resp = await mutateAsyncCreateKit(sendForm)
      if (resp.code === 200) {
        clearSelectedItems(MaterialesKey.selectItemKit)
        reset({})
      }

    } catch (error) {
      handleErrorForm(error as ErrorMessagesForm)
    }

  }

  useLoaders(isPendingEditKit)

  return (
    <>
      <SingleTableBoxScene
        title={title}
        enableCreateOrEditBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.kitInventariable}
        enableBackBtn={true}
        fnCreateOrEdit={handleSubmit(onSubmit)}
      >
        <Grid container spacing={3}>
          <Grid item container spacing={1} xs={12}>
            <CustomTextField
              disabled={true}
              control={control}
              name="fecha_documento"
              defaultValue={formatDateWithTimeAMPM(new Date)}
              size={gridSizeMdLg4}
              label={texto.fecha_documento}
              error={undefined}
              helperText={undefined}
            />

            <CustomTextField
              disabled={true}
              control={control}
              name="usuario"
              defaultValue={razon_social || ''}
              size={gridSizeMdLg4}
              label={'Usuario'}
              error={errors.usuario}
              helperText={errors.usuario?.message}
            />
          </Grid>

          <Grid item container spacing={2} xs={12}>
            <CustomTextField
              control={control}
              name="nombre"
              defaultValue={form.getValues().nombre}
              size={gridSizeMdLg4}
              label={'Nombre del Kit'}
              error={errors.nombre}
              helperText={errors.nombre?.message}
            />

            <CustomAutocomplete<BODEGAS>
              size={gridSizeMdLg4}
              label={texto.bodega}
              name="bodega"
              options={bodegas || []}
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().bodega}
              isLoadingData={isLoadingbodegas}
              control={control}
              error={errors.bodega}
              helperText={errors.bodega?.message}
              onChangeValue={(e: string) => {
                if (!e)
                  return reset({
                    ...form.getValues(), bodega: undefined,
                    ubicacion: undefined
                  });

                reset({ ...form.getValues(), bodega: e, ubicacion: undefined });
              }}
            />

            {form.getValues().bodega && !isLoaUbOrigen && (
              <CustomAutocomplete<Ubicaciones>
                size={gridSizeMdLg4}
                label={'Ubicación'}
                name="ubicacion"
                options={ubOrigen?.data.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={form.getValues().ubicacion || null}
                isLoadingData={isLoaUbOrigen}
                control={control}
                error={errors.ubicacion}
                helperText={errors.ubicacion?.message}
                onChangeRawValue={(e) => {
                  if (e)
                    clearSelectedItems(MaterialesKey.selectItemKit);

                  return reset({ ...form.getValues(), ubicacion: e.codigo });
                }}
              />
            )}

            <CustomTextArea
              rows={1}
              size={gridSizeMdLg4}
              label="Observaciones"
              name="observacion_1"
              control={control}
              defaultValue={form.getValues().observacion_1}
              error={errors.observacion_1}
              helperText={errors.observacion_1?.message}
              required={false}
            />
          </Grid>

          <Grid item {...gridSize}>
            <Paper className="paper">
              <Grid container spacing={1} justifyContent={'space-between'} alignItems={'center'}>
                <Grid item >
                  <TabTextLabel text={'Items Seleccionado'} mt={0} pb={0} pl={0} pt={0} />
                </Grid>
                <Grid item>
                  <ModalProductoSelectComponente
                    onChange={(e) => {
                      const aux: MaterialTransferido = {
                        cantidad: 1,
                        codigo: e.codigo,
                        series: [],
                        ///* aux
                        id: e.id_producto,
                        contiene_serie: e.contiene_serie,
                        producto_data: {
                          codigo: e.codigo,
                          stock_actual: e.stock_actual,
                          categoria_producto: e.categoria_producto,
                          subcategoria_producto: e.subcategoria_producto_data?.nombre ?? 'N/A',
                          descripcion: e.descripcion,
                        },

                      }
                      addSelectedItemProducto(aux, MaterialesKey.selectItemKit);
                    }}
                  />

                </Grid>
                <div className="linea"></div>
                <Grid item xs={12}>
                  <SampleTable<MaterialTransferido>
                    rowNumber={true}
                    columns={columnCreateKitInventario}
                    data={selectItemKit}
                    enableTopToolbar={true}
                  />
                </Grid>

              </Grid>
            </Paper>

          </Grid>


        </Grid>
      </SingleTableBoxScene>

    </>
  )

}